export let rules = {
    task_name: [{
        required: true,
        message: '请输入任务名称',
        trigger: 'blur'
    }],
    applicant_name: [{
        required: true,
        message: '请输入应聘者姓名',
        trigger: 'blur'
    }],
    age: [{
        required: true,
        message: '请输入应聘者年龄',
        trigger: 'blur'
    }],
    applicant_section: [{
        required: true,
        message: '请选择应聘部门',
        trigger: 'change'
    }],
    position_applied: [{
        required: true,
        message: '请选择应聘岗位',
        trigger: 'change'
    }],
    highest_education: [{
        required: true,
        message: '请选择最高学历',
        trigger: 'change'
    }],
    graduate_school: [{
        required: true,
        message: '请选择毕业院校',
        trigger: 'change'
    }],
    major: [{
        required: true,
        message: '请选择毕业专业',
        trigger: 'change'
    }]
}